export default "__VITE_ASSET__08KH$ZHh__"